import React, { useState, useCallback } from "react";
import ChestnyZnakLabeler from "./ChestnyZnakLabeler";
import ScannerCheck from "./ScannerCheck";
import OrderTape from "./OrderTape";
import { LABEL_SIZES } from "./chestnyZnakPrint";
import "./ChestnyZnakLabeler.css";

// Временно скрыты (оставлены в проекте, вернёмся к ним):
//  - BulkKizPrint («Печать КИЗ») и KizBarcodePrint («Печать КИЗ + ШК») —
//    ждём источник ПОЛНЫХ кодов с криптохвостом (файл эмиссии ЧЗ / скан);
//    из коротких КИ (01+21) валидный код собрать нельзя.
//  - SetAggregation («Агрегация наборов») — ждём формат документа ЧЗ.

const DEFAULT_LABEL_SIZE = LABEL_SIZES.find((s) => s.id === "58x40");

const DEFAULT_SETTINGS = {
  font: "Arial",
  labelSize: DEFAULT_LABEL_SIZE,
  rotated: false,
  copies: 1,
  autoPrint: true,
  titleEnabled: false,
  dateFields: { mfg: false, shelf: false, exp: false },
  barcodeEnabled: false,
  barcodeFormat: "CODE128",
};

export default function ChestnyZnakTool() {
  const [mode, setMode] = useState("print");
  // Настройки этикетки (размер, шрифт, доп. элементы) общие для «Печати
  // этикетки» и «Ленты заказов» — задаются один раз, переиспользуются в обоих режимах.
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  const updateSettings = useCallback((patch) => {
    setSettings((prev) => ({ ...prev, ...patch }));
  }, []);

  const MODES = [
    { id: "print", label: "Печать этикетки", render: () => <ChestnyZnakLabeler settings={settings} onSettingsChange={updateSettings} /> },
    { id: "tape",  label: "Лента заказов",   render: () => <OrderTape settings={settings} onSettingsChange={updateSettings} /> },
    { id: "check", label: "Проверка сканера", render: () => <ScannerCheck /> },
  ];

  const active = MODES.find((m) => m.id === mode) || MODES[0];

  return (
    <div className="cz-tool">
      <div className="cz-tool__tabs" role="tablist" aria-label="Режим работы с Честным знаком">
        {MODES.map((m) => (
          <button
            key={m.id}
            type="button"
            role="tab"
            aria-selected={mode === m.id}
            className={`cz-tool__tab${mode === m.id ? " cz-tool__tab--active" : ""}`}
            onClick={() => setMode(m.id)}
          >
            {m.label}
          </button>
        ))}
      </div>

      {active.render()}
    </div>
  );
}
